import { doc, updateDoc } from 'firebase/firestore';
import { firestore } from './firebaseConfig';

export const updateSimulationName = async (simulationId, name) => {
  await updateDoc(doc(firestore, 'simulations', simulationId), { name });
};
